export default __webpack_public_path__ + "static/media/42t.6eb1e5c0.jpg";